import React from "react";
import PdfLayout from '../PdfLayout';
import PdfLayoutWidget from './PdfLayoutWidget';
import { Screen } from '../../services';

/** Class representing a PDF layout image widget. */
class FrameWidget extends PdfLayoutWidget {

    constructor(properties) {
        super({
            ...(FrameWidget.getDefaultOptions()),
            ...properties,
            type: PdfLayout.SHAPE,
            subType: PdfLayout.FRAME
        });
    }

    /**
     * Get this widget default options
     */
    static getDefaultOptions() {
        return {
            position: { x: 2, y: 2, z: 0 },
            dimensions : { width: 5, height: 7.5 },
            transform: { rotation: 0 },
            options: {
                style: {
                    backgroundColor: '#FFFFFF',
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: '#000000',
                    borderRadius: 0
                }
            }
        };
    }

    /**
     * Return the list of options this widget handles
     */
    getHandledOptions() {
        return super.getHandledOptions().concat([
            PdfLayout.OPTION_BACKGROUND_COLOR,
            PdfLayout.OPTION_BORDER_COLOR,
            PdfLayout.OPTION_BORDER_STYLE,
            PdfLayout.OPTION_BORDER_WIDTH,
            PdfLayout.OPTION_BORDER_RADIUS
        ]);
    }

    /**
     * Return this widget preview as JSX string
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {String} lang
     *                 - {Object} setting
     */
    getPreview() {
        const thickness = parseFloat(this.options?.style?.borderWidth) || 0;
        const color = this.options?.style?.borderColor || '#000000';
        const style = this.options?.style?.borderStyle || 'solid';
        // Inset drawing stays inside the page box — CSS borders on a full-page
        // frame are clipped by .preview / .rnd overflow on the right and bottom.
        const frameStyle = {
            top: Screen.cmToPx(this.position.y),
            left: Screen.cmToPx(this.position.x),
            width: Screen.cmToPx(this.dimensions.width),
            height: Screen.cmToPx(this.dimensions.height),
            backgroundColor: this.options?.style?.backgroundColor,
            borderRadius: `${this.options?.style?.borderRadius || 0}px`,
            boxSizing: 'border-box',
        };

        if (thickness > 0 && style === 'dashed') {
            frameStyle.outline = `${thickness}px dashed ${color}`;
            frameStyle.outlineOffset = `-${thickness}px`;
        } else if (thickness > 0) {
            frameStyle.boxShadow = `inset 0 0 0 ${thickness}px ${color}`;
        }

        return <div style={frameStyle} />;
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'square-o';
    }
}

export default FrameWidget;
